export const GAME_MASTER_PATH = "gm";
export const LAST_GAME_MASTER_KEY = "gm";
export const GAME_MASTER_MEMBER_KEY = "gameMasters";
